import { createElementVNode as _createElementVNode, Teleport as _Teleport, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, toDisplayString as _toDisplayString, createElementBlock as _createElementBlock, createTextVNode as _createTextVNode, Fragment as _Fragment } from "vue";
const _hoisted_1 = ["href"];
const _hoisted_2 = {
  class: "catalog-page"
};
const _hoisted_3 = {
  class: "exo"
};
const _hoisted_4 = {
  key: 0
};
const _hoisted_5 = /*#__PURE__*/_createElementVNode("p", null, "No matches; please broaden your search.", -1);
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_filter_box = _resolveComponent("filter-box");
  const _component_el_col = _resolveComponent("el-col");
  const _component_publication_table = _resolveComponent("publication-table");
  const _component_el_row = _resolveComponent("el-row");
  return _openBlock(), _createElementBlock(_Fragment, null, [_ctx.canonicalUrl ? (_openBlock(), _createBlock(_Teleport, {
    key: 0,
    to: "head"
  }, [_createElementVNode("link", {
    rel: "canonical",
    href: `https://shop.geospatial.com/${_ctx.canonicalUrl}`
  }, null, 8, _hoisted_1)])) : _createCommentVNode("", true), _createElementVNode("div", _hoisted_2, [_createVNode(_component_el_row, null, {
    default: _withCtx(() => [_createVNode(_component_el_col, {
      md: 6,
      sm: 24,
      xs: 24,
      class: "filter-box-container"
    }, {
      default: _withCtx(() => [_createVNode(_component_filter_box, {
        title: "filters",
        "onUpdate:modelValue": _ctx.updateFilters,
        onClear: _ctx.resetFilter,
        modelValue: _ctx.editFilters,
        "allow-country-selection": true,
        "allow-publisher-selection": false,
        "blank-filters": _ctx.blankFilters
      }, null, 8, ["onUpdate:modelValue", "onClear", "modelValue", "blank-filters"])]),
      _: 1
    }), _ctx.hasCounts ? (_openBlock(), _createBlock(_component_el_col, {
      key: 0,
      md: 18,
      sm: 24,
      xs: 24
    }, {
      default: _withCtx(() => [_createElementVNode("h3", _hoisted_3, [_createElementVNode("span", null, [_createElementVNode("em", null, _toDisplayString(_ctx.matchCounts?.products.toLocaleString()), 1), _createTextVNode(" matches in "), _createElementVNode("em", null, _toDisplayString(_ctx.matchCounts?.publications.toLocaleString()), 1), _createTextVNode(" series "), _ctx.publisher.gid ? (_openBlock(), _createElementBlock("span", _hoisted_4, "for " + _toDisplayString(_ctx.publisher.fullname), 1)) : _createCommentVNode("", true)])]), _createVNode(_component_publication_table, {
        columns: _ctx.columns,
        filters: _ctx.filters,
        total: _ctx.matchCounts.publications
      }, null, 8, ["columns", "filters", "total"])]),
      _: 1
    })) : (_openBlock(), _createBlock(_component_el_col, {
      key: 1,
      md: 18,
      sm: 24,
      xs: 24
    }, {
      default: _withCtx(() => [_hoisted_5]),
      _: 1
    }))]),
    _: 1
  })])], 64);
}